export class Forms {

    public static ajax(url: string, data?: any, callback?: any, method: string = 'POST', fail?: any) {
        var request = new XMLHttpRequest();
        request.open(method, url);
        request.withCredentials = true;
        request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8;");
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        request.setRequestHeader("Accept", "*/*");
        request.onreadystatechange = function () {
            if (request.readyState != 4) {
                return;
            }
            if (request.status == 200) {
                if (request.getResponseHeader('X-Location')) {
                    window.location.assign(request.getResponseHeader('X-Location'));
                    return false;
                }
                if (callback) {
                    callback(request);
                }
            } else {
                if (fail) {
                    fail(request);
                }
            }
        };
        if (data.formData) {
            request.send(data.formData);
            return;
        }
        request.send(this.serializeData(data));
    }

    public static ajaxFormData(url: string, formData: FormData, callback?: any, fail?: any) {
        var request = new XMLHttpRequest();
        request.open('POST', url);
        request.onreadystatechange = function () {
            if (request.readyState != 4) {
                return;
            }
            if (request.status == 200) {
                if (request.getResponseHeader('X-Location')) {
                    window.location.assign(request.getResponseHeader('X-Location'));
                    return false;
                }
                if (callback) {
                    callback(request);
                }
            } else {
                if (fail) {
                    fail(request);
                }
            }
        };
        request.send(formData);
    }

    public static serializeData(data: object): string {
        var buffer = "";
        for (var name in data) {
            if (!data.hasOwnProperty(name)) {
                continue;
            }
            var value = (data as any)[name];
            buffer += "&" + encodeURIComponent(name) + "=" + encodeURIComponent((value == null) ? "" : value);
        }
        return buffer;
    }

}